
import { Component, Vue, Prop } from 'vue-property-decorator'
import FetchWrapper from '@/classes/fetchWrapper'

const PreviewCollectionModalProps = Vue.extend({
  props: {
    canCancel: Boolean,
    close: Boolean
  }
})

@Component
export default class CreateCollectionModal extends PreviewCollectionModalProps {
  data () {
    return {
      isLoading: false,
      activeStep: 0,
      hasStep2: false,
      searchTerms: '',
      maxNumOfArtefatos: 10,
      words: [],
      articleTitles: [],
      mostFreqWords: []
    }
  }

  get isComponentModalActive () {
    return this.close
  }

  async previewNewCollection () {
    try {
      this.isLoading = true
      var resp = await FetchWrapper.get(encodeURI(`${process.env.VUE_APP_SERVERURL}/generateWordsFromSearchTerms/${this.searchTerms}/${this.maxNumOfArtefatos}`))
      if (resp.error) {
        this.isLoading = false
        this.$buefy.dialog.confirm({
          title: 'Error',
          message: resp.error,
          canCancel: false
        })
      } else {
        this.words = resp.words
        this.mostFreqWords = resp.mostFreqWords
        this.articleTitles = resp.paths
        this.isLoading = false
        // this.previewCollectionOpen = true
        this.activeStep = 1
        if (this.articleTitles.length > 0) {
          this.hasStep2 = true
        } else {
          this.$buefy.dialog.confirm({
            title: 'Error',
            message: 'Found 0 Articles with these search words. Cannot create collection without any articles. Try another search terms.',
            canCancel: false
          })
        }
      }
    } catch (e) {
      this.isLoading = false
      this.$buefy.dialog.confirm({
        title: 'Error',
        message: `Something went wrong. ${e}`,
        canCancel: false
      })
    }
  }

  async createCollection () {
    try {
      this.isLoading = true

      var data = {
        articlePaths: this.articleTitles,
        searchTerms: this.searchTerms,
        numMaxOfArtefatos: Number(this.maxNumOfArtefatos),
        numOfWords: this.words.length
      }

      const resp = await FetchWrapper.post(`${process.env.VUE_APP_SERVERURL}/createCollection`, data)

      this.isLoading = false
      if (resp.error) {
        this.$buefy.dialog.confirm({
          title: 'Error',
          message: resp.error,
          canCancel: false
        })
      } else {
        this.$buefy.dialog.confirm({
          title: 'Success',
          message: 'Collection created Successfully',
          onConfirm: () => {
            this.$emit('created')
            this.$emit('close')
          },
          canCancel: false
        })
      }
    } catch (e) {
      this.isLoading = false
      this.$buefy.dialog.confirm({
        title: 'Error',
        message: `Something went wrong. ${e}`,
        canCancel: false
      })
    }
  }
}
